export enum TVAuthStatus {
    Success = 1,
    Fail = 2,
    Invalid = 3,
    UsernameInvalid = 4,
    PasswordInvalid = 5,
    PortalTimeout = 6,
    PlatformError = 7,
}
